import * as React from 'react';
import { AddMessage } from '../AddMessage/AddMessage';
import { SearchMessage } from '../SearchMessage/SearchMessage';
import * as models from '../../models';
import './CannedMessages.scss';
import {
  Dimmer, Loader, Accordion,
} from 'semantic-ui-react';
import { MessageBanner } from '../MessageBanner/MessageBanner';
import { MessageCategory } from './MessageCategory';
import { AddMessageSection } from '../AddMessage/AddMessageSection';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { FormattedMessage } from 'react-intl';
import { MAX_MESSAGES } from '../../constants';

export interface CannedMessagesProps {
  messageState: models.MessageState;
  addMessage(message: string, tags: number[]): void;
  editMessageRequest(message: models.Message): void;
  deleteMessageRequest(id: number): void;
  viewMessages(): void;
  onSearch(text: string): void;
  messagesPrevPage(): void;
  messagesNextPage(): void;
  logout(): void;
  copyMessage(id: number): void;
  cancelEditMessage(): void;
  dismissMessageBanner(): void;
  showAddMessageSection(): void;
  hideAddMessageSection(): void;
  showEditMessagesView(): void;
  hideEditMessagesView(): void;
  sortMessageRequest(oldIndex: number, newIndex: number, categoryName: string): void;
  categorySortMessageRequest(oldIndex: number, newIndex: number): void;
  categoryCollapsed(id: number, name: string): void;
  categoryExpand(id: number, name: string): void;
}
const CategoryItem = SortableElement((props: any) => {

  const {
    editMessageRequest,
    deleteMessageRequest,
    copyMessage,
    cancelEditMessage,
    sortMessageRequest,
    mCategory,
    index,
    categoryExpand,
    categoryCollapsed,
  } = props.value;

  const {
    isEditMessagesInProgress,
    hasSearchQuery,
    messageCategories,
  } = props.value.messageState;


  return (
    <MessageCategory
      index={index}
      id={mCategory.id}
      messageCategories={messageCategories}
      messages={mCategory.messages}
      categoryName={mCategory.categoryName}
      isEditMessagesInProgress={isEditMessagesInProgress || false}
      hasSearchQuery={hasSearchQuery}
      editMessageRequest={editMessageRequest}
      deleteMessageRequest={deleteMessageRequest}
      copyMessage={copyMessage}
      cancelEditMessage={cancelEditMessage}
      sortMessageRequest={sortMessageRequest}
      categoryCollapsed={categoryCollapsed}
      categoryExpand={categoryExpand}
    />);
});


const CategorySortableList = SortableContainer((props: any) => {
  const {

    messageCategories,
  } = props.messageState;
  return (
    <div>
      {
         messageCategories.map((mCategory: models.MessageCategory, index: number) =>
          (
            mCategory.messages.length > 0
            && (<CategoryItem
              key={index}
              index={index}
              value={{ ...props, mCategory, index }}
            />)
          ))
      }
    </div>);
});

export class CannedMessages extends React.Component<CannedMessagesProps, {}> {
  componentDidMount() {
    this.props.viewMessages();
  }

  onCategorySortEnd = (context: any, trustedContext: any) => {
    this.props.categorySortMessageRequest(
      context.oldIndex,
      context.newIndex);
  }

  hasReachedMaxMessages = () => {
    const { messages } = this.props.messageState;
    return messages && messages.length >= MAX_MESSAGES;
  }

  render() {
    const { addMessage,
      onSearch,
      dismissMessageBanner,
      showAddMessageSection,
      hideAddMessageSection,
    } = this.props;

    const {
      isSearchLoading,
      isAppLoaded,
      statusMessage,
      isAddMessagesInProgress,
      messageCategories,
      messages,
    } = this.props.messageState;

    return (
      <div className="cannedMessagesWrapper">
        <div className="CannedMessages">
          <MessageBanner
            statusMessage={statusMessage}
            dismiss={dismissMessageBanner}
          />
          <div>
            <Dimmer active={!isAppLoaded}>
              <Loader indeterminate={true}>
                <FormattedMessage 
                    id="app.preparing"
                    defaultMessage="Preparing Messages"
                /></Loader>
            </Dimmer>
            <div>
              <div className="cannedMessagesSearch">
                <SearchMessage
                  onSearch={onSearch}
                  isLoading={isSearchLoading || false}
                />
              </div>
              <div>

                <AddMessage
                  isAddMessagesInProgress={isAddMessagesInProgress || false}
                  showAddMessageSection={showAddMessageSection}
                />
              </div>
            </div>
            {isAddMessagesInProgress &&
              <div>
                <AddMessageSection
                  addMessage={addMessage}
                  hideAddMessageSection={hideAddMessageSection}
                  messageCategories={messageCategories}
                  hasReachedMax={this.hasReachedMaxMessages()}
                />
              </div>
            }
            <div className="categories">
              <Accordion>
                <CategorySortableList
                  useDragHandle={true}
                  onSortEnd={this.onCategorySortEnd}
                  helperClass="categoryDragging"
                  {...this.props}
                />
                { 
                 !messages.length && 
                    <div className="noMessagesContainer">
                      No messages found.
                    </div>
                }
              </Accordion>
             
            </div>
          </div>
        </div>
      </div>

    );
  }
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CannedMessages/CannedMessages.tsx